import React from 'react';
import { Navigate } from 'react-router-dom';

const SuperAdminProtectedRoute = ({ children }) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const accessToken = localStorage.getItem('accessToken');

  // Check if user is authenticated and has superuser privileges
  if (!accessToken || !user.is_superuser) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default SuperAdminProtectedRoute;